<template>
    <form ref="form" @submit.prevent="save">
        <DsInputField
            ref="nameInput"
            v-model="tagCategory.name"
            type="text"
            name="title"
            :label="$t('tags.tagCategoryName')"
            required
            autofocus
            :submitted="submitted"
        />

        <DsTextAreaField
            v-model="tagCategory.description"
            type="text"
            name="long"
            :label="$t('tags.tagCategoryDescription')"
            :submitted="submitted"
        />

        <portal to="tagModalHeader">
            <DsFilledButton
                data-qa="create-tag-category-button"
                type="button"
                :loading="saving"
                :disabled="saveDisabled"
                @click="save"
            >
                {{ $t('global.save') }}
            </DsFilledButton>
        </portal>
    </form>
</template>

<script>
import { createTagCategory } from '@/api/tags';

export default {
    props: {
        tagCategories: Array,
    },

    data() {
        return {
            tagCategory: {
                name: '',
                description: '',
            },
            submitted: false,
            saving: false,
        };
    },

    async mounted() {
        await this.$nextTick();

        this.$refs.nameInput?.input_focus();
    },

    computed: {
        saveDisabled() {
            return !this.tagCategory.name.trim().length;
        },
    },

    methods: {
        async save() {
            if (this.saveDisabled) return;

            this.submitted = true;
            this.saving = true;

            const existingCategory = this.findDuplicate();

            if (existingCategory) {
                this.$emit('categoryAdded', existingCategory);
            } else if (this.tagCategory.name.toLowerCase() === 'smart lists') {
                this.$error({ message: this.$t('tags.createTagCategorySmartListsError') });
            } else if (this.$refs.form?.checkValidity()) {
                try {
                    const id = await createTagCategory(this.tagCategory);

                    this.$toast({ message: this.$t('tags.createTagCategorySuccess') });
                    this.$emit('categoryAdded', {
                        ...this.tagCategory,
                        id,
                    });
                } catch (e) {
                    this.$error({ message: this.$t('tags.createTagCategoryError') });
                }
            }

            this.saving = false;
        },

        findDuplicate() {
            return this.tagCategories.find(({ name }) => {
                return name === this.tagCategory.name;
            });
        },
    },
};
</script>
